export const DEFAULT_TIMEZONE = 'Asia/Yekaterinburg';

export const MIN_PASSWORD_LENGTH = 8;
export const MIN_LOGIN_LENGTH = 3;
export const MAX_LOGIN_LENGTH = 32;

export const LOGIN_PATTERN = /^[a-zA-Z0-9_-]+$/u;

export const SYNC_BATCH_LIMIT = 100;
export const PULL_PAGE_LIMIT = 200;
export const PUSH_MAX_ATTEMPTS_BEFORE_RESET = 12;

export const MAX_TASK_TITLE_LENGTH = 500;
export const MAX_TASK_DESCRIPTION_LENGTH = 20_000;
export const MAX_TAG_NAME_LENGTH = 80;
export const MAX_CHECKLIST_TEXT_LENGTH = 500;
export const MAX_HABIT_NAME_LENGTH = 80;
export const MAX_HABIT_DESCRIPTION_LENGTH = 2_000;

/** Палитра тегов — копия TAG_COLORS с сервера (sync.ts). */
export const TAG_COLORS = [
  '#f87171',
  '#fb923c',
  '#fbbf24',
  '#facc15',
  '#a3e635',
  '#4ade80',
  '#2dd4bf',
  '#22d3ee',
  '#38bdf8',
  '#60a5fa',
  '#818cf8',
  '#a78bfa',
  '#c084fc',
  '#e879f9',
  '#f472b6',
  '#94a3b8',
] as const;

export type TagColor = (typeof TAG_COLORS)[number];

export const DEFAULT_TAG_COLOR: TagColor = '#38bdf8';
